module.exports = "<div class=\"flexParent\">\n  <app-empty-cart *ngIf=\"!objectsArray\"></app-empty-cart>\n  <app-cart-item [items]=\"objectsArray\" (updateCart)=\"updateButtonWasClicked($event)\"></app-cart-item>\n</div>\n<app-checkout [subTotal]=\"subTotal\"></app-checkout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/cart/cart.component.html
// module id = 400
// module chunks = 1